import React, {Component, Fragment} from 'react';
import FormContainer from '../form-components/FormContainer';
import Page from '../layout/Page';
import documentsApi from '../../store/services/documents';
import withLifecycles from 'async-lifecycles/index';
import produce from 'immer';
import {
  Button,
  Icon,
  Input,
  Item,
  Pagination,
  Table,
} from 'semantic-ui-react';
import searchImage from '../assets/search.svg';
import styled from 'react-emotion';
import {debounce} from 'lodash';
import documentsService from '../../store/services/documents';

const Styles = styled.div`
  .searchRow {
    background-color: '#f00';
    display: flex;
    flex-grow: 1;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: flex-end;
  }
`;

class ResourceList extends Component {
  state = {
    loading: false,
    pageInfo: {},
    activePage: 1,
    searchTerm: '',
    downloading: false,
  };

  componentDidMount() {
    this._loadResources();
  }

  _loadResources = (pageNumber, searchTerm) => {
    withLifecycles(
      () =>
        documentsApi.getResourceDocuments({
          page: pageNumber,
          searchTerm,
          pageSize: 20,
        }),
      ({loading, data, error}) => {
        this.setState({activePage: pageNumber});
        this.setState(
          produce(draft => {
            draft.loading = loading;

            if (data && !data.hasErrors) {
              draft.pageInfo = data.result;
            }
          })
        );
      }
    );
  };

  _downloadDocuments = async (files, fileName) => {
    if (this.state.downloading) return;

    const baseUrl = process.env.REACT_APP_API_URL || '';

    try {
      this.setState({downloading: true});
      const token = (
        await documentsService.createReportToken({
          documents: files,
        })
      ).result;
      if (token) {
        var url = `${baseUrl}documents/download/${token}?fileName=${fileName}`;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      }
      this.setState({downloading: false});
    } catch (error) {
      this.setState({error, downloading: false});
    }
  };

  render() {
    const {pageInfo, searchTerm, activePage} = this.state;
    const documents = pageInfo.data || [];
    return (
      <Page.Basic title={'Resources'}>
        <FormContainer loading={this.state.loading || this.state.downloading}>
          <Styles>
            <div className="searchRow">
              <Input
                placeholder="Search Resources..."
                onChange={debounce((e, searchTerm) => {
                  this._loadResources(activePage, searchTerm.value);
                  this.setState({searchTerm: searchTerm.value});
                }, 400)}
              />
            </div>
            {pageInfo.pageCount > 0 ? (
              <Fragment>
                <Table basic="very" selectable>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell />
                      <Table.HeaderCell>Name</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    {documents.map(user => this._renderRow(user))}
                  </Table.Body>
                </Table>
                <Pagination
                  activePage={activePage}
                  onPageChange={async (e, paginationInfo) => {
                    await this._loadResources(
                      paginationInfo.activePage,
                      this.state.searchTerm
                    );
                  }}
                  ellipsisItem={{
                    content: <Icon name="ellipsis horizontal" />,
                    icon: true,
                  }}
                  firstItem={{
                    content: <Icon name="angle double left" />,
                    icon: true,
                  }}
                  lastItem={{
                    content: <Icon name="angle double right" />,
                    icon: true,
                  }}
                  prevItem={{content: <Icon name="angle left" />, icon: true}}
                  nextItem={{
                    content: <Icon name="angle right" />,
                    icon: true,
                  }}
                  totalPages={pageInfo.pageCount}
                />
              </Fragment>
            ) : (
              <Item.Group>
                <Item>
                  <Item.Image size="mini" src={searchImage} />
                  <Item.Content verticalAlign="middle">
                    <strong>No Resources found.</strong>
                  </Item.Content>
                </Item>
              </Item.Group>
            )}
          </Styles>
        </FormContainer>
      </Page.Basic>
    );
  }

  _renderRow = document => (
    <Table.Row key={document.fileId}>
      <Table.Cell collapsing>
        <Button
          basic
          icon
          onClick={() => {
            this._downloadDocuments([document.fileId], `${document.documentName}.${document.extension}`);
          }}
        >
          <Icon name="download" />
        </Button>
      </Table.Cell>
      <Table.Cell>{document.documentName}</Table.Cell>
    </Table.Row>
  );
}

export default ResourceList;